<template>
    <div class="faqs-col-content">
        <div class="faqs">
            <h4>What is (Health Maintenance, Inc.) HMI?</h4>
            <p>
                Health Maintenance, Inc. (HMI) is the Heath Maintenance Organization
                (HMO) you have contracted for the delivery of preventive, diagnostic,
                and curative services and/or procedures within its network of Medical
                Service Units (MSU) and affiliated hospitals or medical centers.
            </p>
        </div>
        <div class="faqs">
            <h4>Who are eligible to be HMI Members?</h4>
            <p>
                Applicants who are at least 15 days old and not more than 65 years old.
                However, an applicant of minor age (15 days old to 21 years old) must
                enroll together with a principal of legal age, such as a parent or
                guardian. Coverage is co-terminus with your age; once you have reached
                the age of 65, you will no longer be covered by HMI.
            </p>
        </div>
        <div class="faqs">
            <h4>Can I begin availing of my benefits upon receiving my card?</h4>
            <p>
                You can avail of the medical services upon receiving your HMI card
                within your membership year by simply presenting, on your effective
                date, your card to your HMI Physician-In-Charge (PIC) at your designated
                hospital or at HMICare Clinic & Diagnostic Center, or at HMI
                Coordinating Offices. You may enjoy your HMI benefits for as long as
                your membership status remains active. Kindly Remember. No Card, No
                Service.
            </p>
        </div>
        <div class="faqs">
            <h4>What are the basic benefits to HMI Membership?</h4>
            <p>
                An HMI member in good standing will get free healthcare / medical
                benefits based on the limits of his enrolled healthcare plan or program
                type, such as:
            </p>
            <ul v-for="(benefit, i) in benefits" :key="i">
                <li>{{ benefit }}</li>
            </ul>
        </div>
        <div class="faqs">
            <h4>How do I ensure that my membership is on “Active Status”?</h4>

            <ul v-for="(activeStatus, i) in activeStatuses" :key="i">
                <li>{{ activeStatus }}</li>
            </ul>
        </div>

        <div class="faqs">
            <h4>What happens if my membership is not on “Active Status”?</h4>
            <p>
                Regretfully, you cannot avail of any membership benefits. This happens
                due to one or more of the following reasons:
            </p>
            <ul v-for="(notActiveStatus, i) in notActiveStatuses" :key="i">
                <li>{{ notActiveStatus }}</li>
            </ul>
        </div>

        <div class="faqs">
            <h4>What should I do if I lose my HMI Card?</h4>
            <p>
                Immediately report to HMI Membership Processing Unit concerning your
                lost card by calling (02) 8844-6715 or (02) 8811-1313. Next, you must
                fill out an Affidavit Of Lost Card (downloadable at www.hmi.com.ph),
                then submit the completed form to HMI Membership Processing Unit and pay
                the corresponding processing fee, so that a new HMI Card may be issued
                to you.
            </p>
        </div>

        <div class="faqs">
            <h4>
                Why Should I have to go through an HMI Physician-In-Charge (PIC) when
                availing of my health benefits?
            </h4>
            <p>
                The HMI PIC is the Head of the HMI Group of Doctors and Specialists in
                the HMI Accredited Hospital. The HMI-PIC initially examines you, directs
                treatment, and manages your condition. If there is a need to refer you
                to other specialists, the PIC coordinates this for you by selecting an
                HMI accredited specialist, and will give you the corresponding Referral
                Form needed.
            </p>
            <p>
                For conditions requiring an Emergency Room (ER), you may proceed
                directly to the ER for treatment.
            </p>
        </div>

        <div class="faqs">
            <h4>What happens if the HMI PIC is not available?</h4>
            <p>
                At times the PIC may not be available beyond clinic hours or may have to
                attend to medical emergencies. HMI PICs usually have relievers in case
                they are on official leave. If there are no relievers, you may call the
                HMI Hospital Operations Department at (02) 8811-1313, (02) 8865-3700 or
                (02) 7752-0552 and press zero (0), and hey will assist you and refer
                another HMI accredited physician.
            </p>
            <p>
                You may also proceed to any HMI Hospital Coordinating Office (selected
                hospitals only), or to any HMICare Clinic. The addresses and contact
                numbers are listed in the last page of this Membership Manual. For
                conditions requiring an Emergency Room (ER), you may proceed directly to
                the ER for treatment.
            </p>
        </div>
        <div class="faqs">
            <h4>
                What shall I do if the procedure requested by the PIC or an accredited
                doctor is not available my designated hospital?
            </h4>
            <p>
                HMI always considers your comfort and convenience, though there are some
                medical facilities that may not offer the services you need. In case
                this happens, please call the HMI Hospital Operations Department at (02)
                8811-1313, (02) 8865-3700 or (02) 7752-0552 and press zero (0) to speak
                to an In-House Coordinator who will gladly assist you in locating the
                services you need.
            </p>
        </div>
        <div class="faqs">
            <h4>
                If I am hospitalized due to a vehicular accident, will HMI cover my
                expenses?
            </h4>
            <p>
                By reimbursement only. HMI will not cover outright any hospital expenses
                due to a vehicular accident. However, the amount you have paid for your
                hospital expenses will be reimbursed by HMI if it is proven that the
                vehicular accident is NOT due to your own fault or negligence, and that
                all required documents are submitted to HMI, within 30-days from the
                date of the accident. Likewise, you must execute an agreement to
                subrogate to HMI whatever rights you have by reason of such accident or
                event that gave to such claim to the extent of the value of the services
                rendered. Reimbursement is subject to limits stated in the HMI Service
                Agreement/Contract.
            </p>
        </div>
        <div class="faqs">
            <h4>
                When will a Subrogation Agreement (Deed of Assignment of Rights) be
                required by HMI?
            </h4>
            <p>
                A Subrogation Agreement is required when filing a claim for
                reimbursement for all medico-legal cases, and cases involving a third
                party. Simply put, a Subrogation Agreement states that the member
                assigns to HMI all the rights to any claims as a result of the accident
                to the extent of the value of the services rendered. This includes, but
                is not limited to, any amicable or out-of-court settlements,
                compensation, or indemnity that the member receives from the third
                party. A duly signed Subrogation Agreement, and Quit Claim form, must be
                submitted before the reimbursement check may be released.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        benefits: [
            'Out-Patient Care: Any number of consultations with the HMI PIC/doctors at your designated HMI accredited hospital',
            'Out-Patient Care: Any number of consultations and prescribed laboratory procedures at HMICare Clinic & Diagnostic Center',
            'In-Patient Care: Hospitalization/Confinement',
            'Emergency Care',
            'Dental Care (Optional): for members enrolled with dental benefits',
            'Discounts and other lifestyle partnership incentives',
            'To know more, please visit: www.hmi.com.ph'
        ],
        activeStatuses: [
            'Pay your membership fees on or before your due date',
            'Ensure that your HMI Card is renewed and valid',
            'Settle any and all outstanding charges or bills'
        ],
        notActiveStatuses: [
            'Your membership fees are not paid.',
            'Your membership was not renewed, therefore your card will be considered invalid and expired.',
            'You have outstanding charges or bills.',
            'You did not present your HMI card. No Card, No Service.'
        ]
    })
}
</script>

<style scoped>
.faqs-col-content {
  width: 700px;
  margin: 20px auto;
  /* border: 1px solid red; */
}
.faqs-col-content h3 {
  font-size: 30px;
}

.faqs-col-content h4 {
  width: 80%;
  margin-top: 20px;
  text-align: justify;
  color: #1b5e20;
}

.faqs-col-content ul {
  width: 80%;
}
.faqs-col-content ul li {
  padding-top: 15px;
  font-size: 17px;
  text-align: justify;
}

@media (max-width: 599px) {
  .faqs-col-content h3 {
    text-align: center;
    font-size: 25px;
  }

  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
  .faqs-col-content h3 {
    text-align: center;
    font-size: 25px;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
  .faqs-col-content h3 {
    text-align: center;
    font-size: 28px;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .faqs-col-content {
    width: 45%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
  .faqs-col-content h3 {
    text-align: center;
    font-size: 25px;
  }
}
</style>
